export default __webpack_public_path__ + "static/media/gift8.87fd2b89.png";